import { memo, useCallback, useEffect, useRef } from 'react';
import AnimateTop from 'components/AnimateTop';
import StepLayout from 'components/layout/StepLayout';
import Footer from 'components/footer/Footer';
import { FooterOkBtn, FooterPressText } from 'components/footer/Footer.styled';
import { HiOutlineCheck } from 'react-icons/hi';
import BaseInput from 'components/common/BaseInput';
import { Step1Content } from './Step1.styled';
import { Formik, Form } from 'formik';
import { VALIDATION_STEP_1 } from 'utils/validations';
import { useSelector, useDispatch } from 'react-redux';
import { fillStep1Data } from 'store/slices/form.slice';
import { nextStep, prevStep } from 'store/slices/global.slice';

const Step1 = () => {
  const { firstName, lastName } = useSelector((state) => state.form);
  const dispatch = useDispatch();
  const firstNameRef = useRef(null);

  const onSubmitStep1 = useCallback(
    async (values) => {
      /*TODO: USE REDUX*/
      localStorage.setItem("firstname", values.firstName);
      localStorage.setItem("lastname", values.lastName);
      await dispatch(fillStep1Data(values));
      await dispatch(nextStep());
    },
    [dispatch]
  );

  useEffect(() => {
    if (firstNameRef.current && window.innerWidth > 768) {
      firstNameRef.current.focus();
    }
  }, [firstNameRef]);

  return (
    <AnimateTop>
      <StepLayout title="What's your name?*">
        <Formik
          initialValues={{
            firstName: firstName,
            lastName: lastName,
          }}
          validationSchema={VALIDATION_STEP_1}
          onSubmit={onSubmitStep1}
        >
          {/* {({ isValid, dirty }) => ( */}
          <Form>
            <Step1Content>
              <BaseInput
                name='firstName'
                placeholder='First Name'
                ref={firstNameRef}
              />

              <BaseInput name='lastName' placeholder='Last Name' />
            </Step1Content>
            <Footer prevArrowClick={() => dispatch(prevStep())}>
              <FooterOkBtn type='submit'>
                OK <HiOutlineCheck />
              </FooterOkBtn>
              <FooterPressText>press Enter ↵</FooterPressText>
            </Footer>
          </Form>
          {/* )} */}
        </Formik>
      </StepLayout>
    </AnimateTop>
  );
};

export default memo(Step1);
